import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Product } from '../../types';
import { Badge, ImageWithLoader } from '../ui';
import { formatPrice } from '../../utils/helpers';
import { optimizeImage } from '../../utils/image';
import { cheapestOffer, sharingKindLine, sharingOffers, isLiveOffer } from '../../utils/sharing';

/** Плитка товара шеринга — как плитка игры в каталоге, но ведет в /sharing/:id */
export const SharingTile: React.FC<{ product: Product; horizontal?: boolean }> = ({ product, horizontal = false }) => {
  const navigate = useNavigate();
  const best = cheapestOffer(product);
  const price = best?.price ?? product.minPrice;
  const oldPrice = best?.oldPrice && best.oldPrice > price ? best.oldPrice : null;
  const discount = oldPrice ? Math.round((1 - price / oldPrice) * 100) : 0;
  const several = sharingOffers(product).filter(isLiveOffer).length > 1;

  return (
    <div
      // В ряду подборки плитка той же ширины, что в сетке из двух колонок: половина
      // содержимого ряда минус половина зазора 12px (как плитки «Лидеров продаж» в каталоге)
      className={`cursor-pointer active:scale-[0.97] transition-transform ${horizontal ? 'flex-shrink-0 w-[calc(50%-6px)]' : ''}`}
      onClick={() => navigate(`/sharing/${product.id}`)}
    >
      <div className="relative mb-2.5">
        <ImageWithLoader
          src={optimizeImage(product.coverImage, 400)}
          alt={product.name}
          wrapperClassName="w-full aspect-square rounded-[14px]"
          className="object-cover"
          spinnerSize={20}
          fallbackSrc="https://via.placeholder.com/300x300/f3f4f6/9ca3af?text=PS"
        />
        {discount > 0 && (
          <div className="absolute top-2 left-2 z-20">
            <Badge variant="discount" size="sm">−{discount}%</Badge>
          </div>
        )}
      </div>
      <h3 className="line-clamp-1 mb-0.5" style={{ fontFamily: 'Manrope, sans-serif', fontSize: '17px', fontWeight: 700, lineHeight: '22px', letterSpacing: '-0.2px', color: '#1A1D1A' }}>
        {product.name}
      </h3>
      <p className="line-clamp-1 mb-1" style={{ fontSize: '13px', fontWeight: 400, lineHeight: '16px', letterSpacing: '-0.08px', color: '#818384' }}>
        {product.subtitle ? `${product.subtitle} · ` : ''}{sharingKindLine(product)}
      </p>
      <div className="flex items-baseline gap-1.5">
        <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '17px', fontWeight: 700, lineHeight: '22px', color: '#1A1D1A' }}>
          {several ? 'от ' : ''}{formatPrice(price)}
        </p>
        {oldPrice && (
          <span className="line-through" style={{ fontSize: '13px', color: '#B0B3BA' }}>{formatPrice(oldPrice)}</span>
        )}
      </div>
    </div>
  );
};
